// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"0":"9a628067","504":"965f8a44"}[chunkId] + ".chunk.css");